import { render, staticRenderFns } from "./Departamentos.vue?vue&type=template&id=069ce346&lang=pug"
import script from "./Departamentos.vue?vue&type=script&lang=js"
export * from "./Departamentos.vue?vue&type=script&lang=js"
import style0 from "./Departamentos.vue?vue&type=style&index=0&id=069ce346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports